// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/artifacts/v1/export.proto (package chalk.artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CDCSource } from "./cdc_pb";
import { file_chalk_artifacts_v1_cdc } from "./cdc_pb";
import type { Chart } from "./chart_pb";
import { file_chalk_artifacts_v1_chart } from "./chart_pb";
import type { CronAggregateBackfill } from "./cron_aggregate_backfill_pb";
import { file_chalk_artifacts_v1_cron_aggregate_backfill } from "./cron_aggregate_backfill_pb";
import type { CronQuery } from "./cron_query_pb";
import { file_chalk_artifacts_v1_cron_query } from "./cron_query_pb";
import type { ChalkError } from "../../common/v1/chalk_error_pb";
import { file_chalk_common_v1_chalk_error } from "../../common/v1/chalk_error_pb";
import type { Graph } from "../../graph/v1/graph_pb";
import { file_chalk_graph_v1_graph } from "../../graph/v1/graph_pb";
import type { LSP } from "../../lsp/v1/lsp_pb";
import { file_chalk_lsp_v1_lsp } from "../../lsp/v1/lsp_pb";
import type { GlobalVariablesInfo } from "../../python/v1/types_pb";
import { file_chalk_python_v1_types } from "../../python/v1/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/artifacts/v1/export.proto.
 */
export const file_chalk_artifacts_v1_export: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_artifacts_v1_cdc, file_chalk_artifacts_v1_chart, file_chalk_artifacts_v1_cron_aggregate_backfill, file_chalk_artifacts_v1_cron_query, file_chalk_common_v1_chalk_error, file_chalk_graph_v1_graph, file_chalk_lsp_v1_lsp, file_chalk_python_v1_types]);

/**
 * @generated from message chalk.artifacts.v1.EnvironmentSettings
 */
export type EnvironmentSettings = Message<"chalk.artifacts.v1.EnvironmentSettings"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string runtime = 2;
   */
  runtime?: string;

  /**
   * @generated from field: optional string requirements = 3;
   */
  requirements?: string;

  /**
   * @generated from field: optional string dockerfile = 4;
   */
  dockerfile?: string;

  /**
   * @generated from field: repeated string requires_packages = 5 [deprecated = true];
   * @deprecated
   */
  requiresPackages: string[];

  /**
   * @generated from field: optional string platform_version = 6;
   */
  platformVersion?: string;
};

/**
 * Describes the message chalk.artifacts.v1.EnvironmentSettings.
 * Use `create(EnvironmentSettingsSchema)` to create a new message.
 */
export const EnvironmentSettingsSchema: GenMessage<EnvironmentSettings> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 0);

/**
 * @generated from message chalk.artifacts.v1.ProjectSettings
 */
export type ProjectSettings = Message<"chalk.artifacts.v1.ProjectSettings"> & {
  /**
   * @generated from field: string project = 1;
   */
  project: string;

  /**
   * @generated from field: repeated chalk.artifacts.v1.EnvironmentSettings environments = 2;
   */
  environments: EnvironmentSettings[];

  /**
   * @generated from field: chalk.artifacts.v1.ValidationSettings validation = 3;
   */
  validation?: ValidationSettings;
};

/**
 * Describes the message chalk.artifacts.v1.ProjectSettings.
 * Use `create(ProjectSettingsSchema)` to create a new message.
 */
export const ProjectSettingsSchema: GenMessage<ProjectSettings> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 1);

/**
 * @generated from message chalk.artifacts.v1.MetadataSettings
 */
export type MetadataSettings = Message<"chalk.artifacts.v1.MetadataSettings"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string missing = 2;
   */
  missing: string;
};

/**
 * Describes the message chalk.artifacts.v1.MetadataSettings.
 * Use `create(MetadataSettingsSchema)` to create a new message.
 */
export const MetadataSettingsSchema: GenMessage<MetadataSettings> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 2);

/**
 * @generated from message chalk.artifacts.v1.FeatureSettings
 */
export type FeatureSettings = Message<"chalk.artifacts.v1.FeatureSettings"> & {
  /**
   * @generated from field: repeated chalk.artifacts.v1.MetadataSettings metadata = 1;
   */
  metadata: MetadataSettings[];
};

/**
 * Describes the message chalk.artifacts.v1.FeatureSettings.
 * Use `create(FeatureSettingsSchema)` to create a new message.
 */
export const FeatureSettingsSchema: GenMessage<FeatureSettings> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 3);

/**
 * @generated from message chalk.artifacts.v1.ResolverSettings
 */
export type ResolverSettings = Message<"chalk.artifacts.v1.ResolverSettings"> & {
  /**
   * @generated from field: repeated chalk.artifacts.v1.MetadataSettings metadata = 1;
   */
  metadata: MetadataSettings[];
};

/**
 * Describes the message chalk.artifacts.v1.ResolverSettings.
 * Use `create(ResolverSettingsSchema)` to create a new message.
 */
export const ResolverSettingsSchema: GenMessage<ResolverSettings> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 4);

/**
 * @generated from message chalk.artifacts.v1.ValidationSettings
 */
export type ValidationSettings = Message<"chalk.artifacts.v1.ValidationSettings"> & {
  /**
   * @generated from field: chalk.artifacts.v1.FeatureSettings feature = 1;
   */
  feature?: FeatureSettings;

  /**
   * @generated from field: chalk.artifacts.v1.ResolverSettings resolver = 2;
   */
  resolver?: ResolverSettings;
};

/**
 * Describes the message chalk.artifacts.v1.ValidationSettings.
 * Use `create(ValidationSettingsSchema)` to create a new message.
 */
export const ValidationSettingsSchema: GenMessage<ValidationSettings> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 5);

/**
 * @generated from message chalk.artifacts.v1.FailedImport
 */
export type FailedImport = Message<"chalk.artifacts.v1.FailedImport"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: string module = 2;
   */
  module: string;

  /**
   * @generated from field: string traceback = 3;
   */
  traceback: string;
};

/**
 * Describes the message chalk.artifacts.v1.FailedImport.
 * Use `create(FailedImportSchema)` to create a new message.
 */
export const FailedImportSchema: GenMessage<FailedImport> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 6);

/**
 * @generated from message chalk.artifacts.v1.ChalkpyInfo
 */
export type ChalkpyInfo = Message<"chalk.artifacts.v1.ChalkpyInfo"> & {
  /**
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * @generated from field: optional string python = 2;
   */
  python?: string;
};

/**
 * Describes the message chalk.artifacts.v1.ChalkpyInfo.
 * Use `create(ChalkpyInfoSchema)` to create a new message.
 */
export const ChalkpyInfoSchema: GenMessage<ChalkpyInfo> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 7);

/**
 * @generated from message chalk.artifacts.v1.ValidationLog
 */
export type ValidationLog = Message<"chalk.artifacts.v1.ValidationLog"> & {
  /**
   * @generated from field: string header = 1;
   */
  header: string;

  /**
   * @generated from field: string subheader = 2;
   */
  subheader: string;

  /**
   * @generated from field: chalk.artifacts.v1.ValidationLogSeverity severity = 3;
   */
  severity: ValidationLogSeverity;
};

/**
 * Describes the message chalk.artifacts.v1.ValidationLog.
 * Use `create(ValidationLogSchema)` to create a new message.
 */
export const ValidationLogSchema: GenMessage<ValidationLog> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 8);

/**
 * @generated from message chalk.artifacts.v1.Export
 */
export type Export = Message<"chalk.artifacts.v1.Export"> & {
  /**
   * @generated from field: chalk.graph.v1.Graph graph = 1;
   */
  graph?: Graph;

  /**
   * @generated from field: repeated chalk.artifacts.v1.CronQuery crons = 2;
   */
  crons: CronQuery[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.CronAggregateBackfill cron_aggregate_backfills = 12;
   */
  cronAggregateBackfills: CronAggregateBackfill[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.Chart charts = 3;
   */
  charts: Chart[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.CDCSource cdc_sources = 4;
   */
  cdcSources: CDCSource[];

  /**
   * @generated from field: chalk.artifacts.v1.ProjectSettings config = 5;
   */
  config?: ProjectSettings;

  /**
   * @generated from field: chalk.artifacts.v1.ChalkpyInfo chalkpy = 6;
   */
  chalkpy?: ChalkpyInfo;

  /**
   * @generated from field: repeated chalk.artifacts.v1.FailedImport failed = 7;
   */
  failed: FailedImport[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.ValidationLog logs = 8;
   */
  logs: ValidationLog[];

  /**
   * @generated from field: chalk.lsp.v1.LSP lsp = 9;
   */
  lsp?: LSP;

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError conversion_errors = 10;
   */
  conversionErrors: ChalkError[];

  /**
   * Populated only when explicitly requested by the exporter.
   *
   * @generated from field: chalk.python.v1.GlobalVariablesInfo captured_global_variables = 11;
   */
  capturedGlobalVariables?: GlobalVariablesInfo;
};

/**
 * Describes the message chalk.artifacts.v1.Export.
 * Use `create(ExportSchema)` to create a new message.
 */
export const ExportSchema: GenMessage<Export> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_export, 9);

/**
 * @generated from enum chalk.artifacts.v1.ValidationLogSeverity
 */
export enum ValidationLogSeverity {
  /**
   * @generated from enum value: VALIDATION_LOG_SEVERITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Space field numbers out in case we need to add more
   * levels and have it be numerically congruent.
   *
   * @generated from enum value: VALIDATION_LOG_SEVERITY_INFO = 4;
   */
  INFO = 4,

  /**
   * @generated from enum value: VALIDATION_LOG_SEVERITY_WARNING = 8;
   */
  WARNING = 8,

  /**
   * @generated from enum value: VALIDATION_LOG_SEVERITY_ERROR = 12;
   */
  ERROR = 12,
}

/**
 * Describes the enum chalk.artifacts.v1.ValidationLogSeverity.
 */
export const ValidationLogSeveritySchema: GenEnum<ValidationLogSeverity> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_export, 0);

